import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { toast } from "@volca/ui/lib/toast";
import { openSupportChatWithMessage } from "@/core/pylon";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";

export const ProductContact = ({ product }: { product: MarketingProduct }) => {
  const content = PRODUCT_MARKETING[product];
  const contactUs = () => {
    if (
      !openSupportChatWithMessage(
        `Hi! I am interested in ${content.name}. Can you help enable it for our account?`,
      )
    ) {
      toast.error(
        "Chat could not open. Please refresh the page and try again.",
      );
    }
  };
  return (
    <Stack align="start" gap={2}>
      <Button size="lg" onClick={contactUs}>
        Contact us
        <ArrowRightIcon aria-hidden data-icon="inline-end" />
      </Button>
      <Text tone="muted" className="max-w-xs">
        Talk with our team about setup for your business.
      </Text>
    </Stack>
  );
};
